interface ISiteElementShoppingCartResponse
{
    trolley: string;
    price: string;
    items: ISiteElementShoppingCartItem[];
    previouslyOrderedItems: ISiteElementShoppingCartItem[];
}

interface ISiteElementShoppingCartItem
{
    id: string;
    orderId: string;
    name: string;
    description: string;
    quantity: number;
    quantityPerUnit: number;
    price: string;
    priceTotal: string;
    isPending: boolean;
}

class SiteElementShoppingCart
    extends QueryElement<HTMLElement> {
    
    private readonly _site: Site;

    private readonly _number: IQueryElement;
    private readonly _price: IQueryElement;
    private readonly _trolley: IQueryElement;
    private readonly _container: SiteElementShoppingCartContainer;
    private _results?: ISiteElementShoppingCartResponse;
    
    constructor(element: HTMLElement, site: Site) {
        super(element);

        this._site = site;

        let number = this.query(".number").first<IQueryElement>();
        let price = this.query(".price").first<IQueryElement>();
        let trolley = this.query(".trolley").first<IQueryElement>();
        let container = this.query(".details .container").first<IQueryElement>();

        if (number == null || price == null || trolley == null || container == null)
            throw "Element(s) not found!";

        let containerElement = container.get() as HTMLElement;
        if (containerElement == null)
            throw "Could not extract HTMLElement!";

        this._number = number;
        this._price = price;
        this._trolley = trolley;
        this._container = new SiteElementShoppingCartContainer(this, containerElement);

        this.reload();
    }

    getSite() {
        return this._site;
    }

    getItem(id: string) {
        if (this._results == null)
            return null;
        
        var results = this._results.items.filter(a => a.orderId == id);
        results.concat(this._results.previouslyOrderedItems.filter(a => a.orderId == id));

        return results;
    }

    async reload() {
        let request = new QueryRequest('/Cart/Get', {
            contentType: 'json',
            method: 'get'
        });

        let response = await request.request();
        let jsonResponse: ISiteElementShoppingCartResponse = await response.json();
        this._results = jsonResponse;

        this._number.setHtml(jsonResponse.items.length.toString());
        this._trolley.setHtml(jsonResponse.trolley);
        this._price.setHtml(jsonResponse.price);
        this._container.addItems(jsonResponse.items);
    }
}

class SiteElementShoppingCartContainer
    extends QueryElement<HTMLElement> {

    private _cart: SiteElementShoppingCart;

    constructor(cart: SiteElementShoppingCart, element: HTMLElement) {
        super(element);

        this._cart = cart;
    }
    addItems(items: ISiteElementShoppingCartItem[]) {
        // Remove old items
        for(let x of this.children()) {
            x.remove();
        }
        // Add new items
        for(let x of items) {
            new SiteElementShoppingCartContainerItem(this._cart, x)
                .appendTo(this);
        }
    }
}

class SiteElementShoppingCartContainerItem
extends QueryElement<HTMLElement> {

    private _cart: SiteElementShoppingCart;

    constructor(cart: SiteElementShoppingCart, item: ISiteElementShoppingCartItem) {
        super(document.createElement("dl"));

        this._cart = cart;

        var title = QueryElement.QueryElement("dt");
        title.setHtml(item.name + " " + item.description);

        var container = QueryElement.QueryElement("dd");
        QueryElement.QueryElement("span")
            .setHtml(item.quantity + " x " + item.quantityPerUnit)
            .appendTo(container);
        QueryElement.QueryElement("span")
            .setHtml("x " + item.price)
            .appendTo(container);
        QueryElement.QueryElement("span")
            .setHtml("= " + item.priceTotal)
            .appendTo(container);
        
        var button : SiteElementButton;
        if (item.isPending)
        {
            var button = new SiteElementButton({
                icon: "schedule",
                title: ""
            });
        }
        else
        {
            var button = new SiteElementButton({
                icon: "clear",
                title: ""
            });
    
            button.on("click", async () =>  {
                let request = new QueryRequest(
                    `/Cart/Delete/${item.id}`, {
                    contentType: 'json',
                    method: 'get'
                });
    
                var response = await request.request();
                var jsonResponse: IResponse = await response.json();
                switch(jsonResponse.type)
                {
                    case "Cart":
                    {
                        let payLoad = <ICartPayloadResponse>jsonResponse.payLoad;
                        this._cart.getSite().eventAddedPreOrder();
                    }
                }
            });
        }


        this.append(title).append(container).append(button);
    }
}